import { render, staticRenderFns } from "./browsIndex.vue?vue&type=template&id=43111f88&"
import script from "./browsIndex.vue?vue&type=script&lang=js&"
export * from "./browsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports